import { Component, AfterViewInit, ViewChild, ElementRef } from '@angular/core';
import { GridOptions, DateFilter } from 'ag-grid';
import { Router } from '@angular/router';

import * as encoding from 'encoding-japanese';

import { StockInoutService } from '../../../service/stock-inout/stock-inout.service';
import { CommonService } from '../../../service/common/common.service';
import { DialogsService } from '../../../../component/dialog/dialogs.service';
import { environment } from '../../../../environments/environment';
import { config } from '../../../util/config';
import { insertcomma } from '../../../util/util';
import { PostDataSource } from '../../../classes/dataSource/postDataSource';
import { AgGridHelper } from '../../../util/AgGridHelper';
import { GridButtonRenderComponent } from '../../../render/grid-button-render.component';
import { filter } from 'rxjs/operator/filter';
import { TypeOperationService } from '../../../service/type-operation/type-operation.service';

@Component({
  selector: 'app-wa6020',
  templateUrl: './wa6020.component.html',
  styleUrls: ['./wa6020.component.scss']
})
export class Wa6020Component implements AfterViewInit {
  private gridApi: any;
  public componentTitle = 'WA6020:受払照会';

  public gridOptions: GridOptions;
  public showGrid: boolean;
  public rowData: any[];

  public ownerId: number;
  public ownerResult: any;

  public working = false;
  public containerHeight = 500;
  public cardHeight = 500;
  public gridHeight = 500;
  public production = environment.production;
  public backgroundColor: string;
  public rowsPerPage = config.rowsPerPageSize;
  public rowsPerPageModel = [{ value: 500, viewValue: '500' }, { value: 5000, viewValue: '5000' }];

  private postDataSource: PostDataSource;
  private errorInfo = '';
  private searchKeyItemcode = null;
  private searchKeyOwnerTx = null;
  private searchKeyKubun: any[];
  private searchKeyKubunSelected = '';
  private startDate = null;
  private endDate = null;
  private startDateBook = null;
  private endDateBook = null;  
  private paginationGetRowCount = 0;
  private paginationGetTotalPages = 0;
  private paginationGetCurrentPage = 0;
  private paginationGoToFirstPage;
  private paginationGoToNextPage;

  private isShowSearchBlock = true;
  private isOwnerLinked: boolean = false;

  @ViewChild('gridView')
  private gridView: ElementRef;
  private gridHelper: AgGridHelper;

  private isShowCSVDownloadModal = false;
  private csvDownloadType = null;
  private errorInfoForCSV = '';
  private isCSVDownloadButtonEnabled = false;

  private isEnableClearFilter = null;
  private isShow6022 = false;
  private selectedCount = 0;

  private itemCodeCls = '';
  private kubunCls = '';
  private startDateCls = '';
  private endDateCls = '';
  private editNode = null;
  private loading;
  private isOwnerSearchNone = false;

  private gridSelectAll = false;
  private isDatasourceInit = false;

  constructor(
    private router: Router,
    private stockInoutService: StockInoutService,
    private commonService: CommonService,
    private dialogsService: DialogsService,
    private typeOperationService: TypeOperationService
  ) {
    let ownerResult = sessionStorage.getItem('ownerResult');
    if (ownerResult !== null) {
      const selectedOwner = JSON.parse(ownerResult);
      this.ownerId = selectedOwner.ownerId;
      this.searchKeyOwnerTx = selectedOwner.ownerTx;
    }

    const querystrings = this.ownerId ? { ownerId: this.ownerId } : '';
    const result = JSON.parse(sessionStorage.getItem('loginResult'));
    //SessionStorageからユーザ情報を取得、荷主ユーザか判定
    if (result !== null) {
      let user = result.user;
      this.isOwnerLinked = user.roleId == 3 ? true : false;
    }
    this.postDataSource = new PostDataSource({
      parent: this,
      service: this.stockInoutService,
      resultKey: 'stockinouts',
      querystrings: querystrings,
      beforeRequest: this.handleBeforeRequest.bind(this),
      successCallback: this.handleRequestSucc.bind(this)
    });
    this.gridHelper = new AgGridHelper();
    this.gridHelper.scrollArrowCustomVarietyValue = -121;
    this.gridOptions = <GridOptions>{
      pagination: true,
      rowModelType: 'infinite',
      paginationPageSize: this.rowsPerPage,
      enableServerSideSorting: true,
      enableServerSideFilter: true,
      cacheBlockSize: Number(this.rowsPerPage),
      onColumnResized: this.saveColumnWidth,
      rowSelection: 'multiple',
      floatingFilter: true,
      enableRangeSelection: true,
      localeText: environment.gridLocale,
      getContextMenuItems: this.getContextMenuItems,

      onColumnMoved: () => {
        this.saveColumnOrder();
      },
      onGridReady: params => {
        this.gridApi = params;
        const columns = [];
        for (const column of params.columnApi.getAllDisplayedColumns()) {
          const idx = localStorage.getItem(`wa6020_${column.getColId()}_idx`);
          if (idx !== null) {
            columns.push({ idx: parseInt(idx, 10), column: column });
          }
        }
        columns.sort((a, b) => {
          return a.idx - b.idx;
        });
        for (let i = columns.length - 1; i >= 0; i--) {
          const column = columns[i];
          params.columnApi.moveColumn(column.column, column.idx);
        }
        this.gridHelper.onGridReady();
        this.fixedDateFilterInput();
        this.gridHelper.renderGridCheckboxImage();
        this.gridHelper.hidePaginiation();
        this.fixedSelectAll()
      },
      onFilterChanged: () => {
        console.log('----- on filter chagned');
        this.errorInfo = '';
        this.isEnableClearFilter = this.gridOptions.api.isAnyFilterPresent();
        this.gridHelper.onGridFilterChanged();
      },
      onPaginationChanged: () => {
        if (this.postDataSource['init'] == false) return;
        this.paginationGetRowCount = this.gridOptions.api.paginationGetRowCount();
        this.paginationGetTotalPages = this.gridOptions.api.paginationGetTotalPages();
        this.paginationGetCurrentPage = this.gridOptions.api.paginationGetCurrentPage() + 1;

        this.isCSVDownloadButtonEnabled = this.gridOptions.api.getDisplayedRowCount() > 0;
        this.gridHelper.renderGridCheckboxImage();
        this.gridHelper.renderScrollArrow();
        this.gridHelper.autoTogglePagination();
        this.gridHelper.onRowDataChanged();

        if (this.gridSelectAll) {
          this.selectedCount = 0
          this.selectAllClick()
        }
      },
      onRowDataChanged: () => {
        this.errorInfo = '';
        this.gridHelper.onRowDataChanged();

        /*
        Observable.timer(100).subscribe(() => {
          this.searchByKey();
        });*/
      },
      overlayLoadingTemplate: this.gridHelper.TEMPLATE_GRID_LOADING,
      overlayNoRowsTemplate: this.gridHelper.TEMPLATE_GRID_NODATA,
      postProcessPopup: params => {
        this.errorInfo = '';
        this.gridHelper.fixedAgMenu();
      },
      onSortChanged: () => {
        this.errorInfo = '';
        this.gridHelper.renderGridCheckboxImage();
      },
      onSelectionChanged: () => {
        this.errorInfo = '';
        this.selectedCount = this.gridOptions.api.getSelectedRows().length;
      }
    };
    this.gridOptions.columnDefs = [
      {
        headerName: '',
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        suppressSorting: true,
        suppressFilter: true,
        width: 30,
        cellClass: ['tc', 'cl_w', 'noCellFocus'],
        suppressMenu: true,
        pinned: 'left',
        suppressMovable: true
      },
      {
        headerName: '',
        field: 'col1',
        pinned: 'left',
        suppressMenu: true,
        width: 95,
        cellClass: ['tc', 'cellclass'],
        suppressMovable: true,
        cellRendererFramework: GridButtonRenderComponent,
        cellStyle: this.isOwnerLinked?{ display: 'none' }:'',
        cellRendererParams: {
          buttonText: '修正',
          onClick: this.onEditButtonClick.bind(this)
        }
      },
      {
        headerName: '受払ID',
        headerTooltip: '受払ID',
        field: 'stockinoutId',
        sort: 'desc',
        width: this.getColumnWidth('stockinoutId', 100),
        filter: 'text',
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '確定',
        headerTooltip: '確定',
        field: 'commitTx',
        width: this.getColumnWidth('commitTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        field: 'ownerId',
        hide:true
      },
      {
        headerName: '荷主名',
        headerTooltip: '荷主名',
        field: 'ownerTx',
        width: this.getColumnWidth('ownerTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '発生日',
        headerTooltip: '発生日',
        field: 'originalDt',
        width: this.getColumnWidth('originalDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '計上日',
        headerTooltip: '計上日',
        field: 'bookDt',
        width: this.getColumnWidth('bookDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '計上年月',
        headerTooltip: '計上年月',
        field: 'bookyearmonthTx',
        width: this.getColumnWidth('bookyearmonthTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション',
        headerTooltip: 'ロケーション',
        field: 'locaCd',
        width: this.getColumnWidth('locaCd', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケーション名',
        headerTooltip: 'ロケーション名',
        field: 'locaTx',
        width: this.getColumnWidth('locaTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロケブロック',
        headerTooltip: 'ロケブロック',
        field: 'locablockTx',
        width: this.getColumnWidth('locablockTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品コード',
        headerTooltip: '商品コード',
        field: 'itemCd',
        width: this.getColumnWidth('itemCd', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '商品名',
        headerTooltip: '商品名',
        field: 'itemTx',
        width: this.getColumnWidth('itemTx', 150),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '在庫区分',
        headerTooltip: '在庫区分',
        field: 'typestockTx',
        width: this.getColumnWidth('typestockTx', 80),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'ロット',
        headerTooltip: 'ロット',
        field: 'lotTx',
        width: this.getColumnWidth('lotTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '使用期限',
        headerTooltip: '使用期限',
        field: 'uselimitDt',
        width: this.getColumnWidth('uselimitDt', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '単位名',
        headerTooltip: '単位名',
        field: 'unitTx',
        width: this.getColumnWidth('unitTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '入数',
        headerTooltip: '入数',
        field: 'amountNr',
        width: this.getColumnWidth('amountNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        headerName: '数量',
        headerTooltip: '数量',
        field: 'pcsNr',
        width: this.getColumnWidth('pcsNr', 80),
        valueFormatter: insertcomma,
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tr', 'cellclass']
      },
      {
        field: 'typeoperationCd',
        hide: true
      },
      {
        headerName: '業務区分名',
        headerTooltip: '業務区分名',
        field: 'typeoperationTx',
        width: this.getColumnWidth('typeoperationTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '指示番号',
        headerTooltip: '指示番号',
        field: 'refnoTx',
        width: this.getColumnWidth('refnoTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'トランザクション区分',
        headerTooltip: 'トランザクション区分',
        field: 'typetrnTx',
        width: this.getColumnWidth('typetrnTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: 'トランザクション区分枝',
        headerTooltip: 'トランザクション区分枝',
        field: 'typetrnsubTx',
        width: this.getColumnWidth('typetrnsubTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '備考',
        headerTooltip: '備考',
        field: 'stockinoutmemoTx',
        width: this.getColumnWidth('stockinoutmemoTx', 120),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外',
        headerTooltip: '請求対象外',
        field: 'notinvoiceTx',
        width: this.getColumnWidth('notinvoiceTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外日時',
        headerTooltip: '請求対象外日時',
        field: 'notinvoiceDt',
        width: this.getColumnWidth('notinvoiceDt', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '請求対象外者名',
        headerTooltip: '請求対象外者名',
        field: 'notinvoiceuserTx',
        width: this.getColumnWidth('notinvoiceuserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新日時',
        headerTooltip: '更新日時',
        field: 'updDt',
        width: this.getColumnWidth('updDt', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '更新者名',
        headerTooltip: '更新者名',
        field: 'upduserTx',
        width: this.getColumnWidth('upduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録日時',
        headerTooltip: '登録日時',
        field: 'addDt',
        width: this.getColumnWidth('addDt', 140),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      },
      {
        headerName: '登録者名',
        headerTooltip: '登録者名',
        field: 'adduserTx',
        width: this.getColumnWidth('adduserTx', 100),
        unSortIcon: true,
        suppressMenu: true,
        cellClass: ['tl', 'cellclass']
      }
    ];
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
    this.gridHeight = window.innerHeight - config.headerMargin - config.containerButtonMargin;
    if (this.production) {
      this.backgroundColor = 'primary';
    } else {
      this.backgroundColor = 'warn';
    }
    this.searchKeyKubun = [];
    this.gridHelper.setGridOptions(this.gridOptions);
    this.gridHelper.onViewportScrollListener = () => {
      this.fixedDateFilterInput();
    };
  }

  fixedDateFilterInput() {
    var dateFilter = this.gridView.nativeElement.querySelector('.ag-filter-filter');
    if (dateFilter == null) return;
    dateFilter.classList.add('ag-floating-filter-input');
    dateFilter.placeholder = '';
  }
  getColumnWidth(id: string, def: number): number {
    return parseInt(localStorage.getItem(`wa6020_${id}_width`), 10) || def;
  }

  saveColumnWidth(params) {
    if (params.finished === true && params.type === 'columnResized') {
      localStorage.setItem(`wa6020_${params.column.colId}_width`, params.column.actualWidth);
    }
  }

  saveColumnOrder() {
    let idx = 0;
    for (const column of this.gridApi.columnApi.getAllDisplayedColumns()) {
      localStorage.setItem(`wa6020_${column.colId}_idx`, `${idx}`);
      idx++;
    }
  }

  getContextMenuItems(params) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    const download = csvString => {
      // Unicode コードポイントの配列に変換する
      const unicode_array = str_to_unicode_array(csvString);
      // S-JIS コードポイントの配列に変換
      const sjis_code_array = encoding.convert(
        unicode_array, // ※文字列を直接渡すのではない点に注意
        'SJIS', // to
        'UNICODE' // from
      );
      // 文字コード配列をTypedArrayに変換する
      const uint8_array = new Uint8Array(sjis_code_array);
      // 指定されたデータを保持するBlobを作成する
      const blob = new Blob([uint8_array], { type: 'text/csv' });
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = 'export.csv';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    };

    const result = [
      'copy',
      'copyWithHeaders',
      'separator',
      {
        name: 'チェックした行をCSVエクスポート',
        action: () => {
          download(params.api.getDataAsCsv({ onlySelected: true }));
        }
      }
    ];

    return result;
  }

  onResize(event) {
    this.containerHeight = window.innerHeight - config.containerheaderMargin;
    this.cardHeight = window.innerHeight - config.headerMargin;
  }

  onResizeGrid(event) {
    this.gridHeight = event.target.innerHeight - config.headerMargin - config.containerButtonMargin;
  }

  ngAfterViewInit() {
    this.gridHelper.el = this.gridView;

    this.typeOperationService
      .get()
      .then(resp => {
        this.searchKeyKubun = resp['typeoperations'];
      })
      .catch(error => {
        this.searchKeyKubun = [];
      });

    let Fromdate = new Date();
    let Todate = new Date();
    Todate.setDate(Todate.getDate() + 1);
    setTimeout(() => {
      this.startDate = Fromdate.getFullYear() + '-' + this.pad(Fromdate.getMonth() + 1, 2) + '-' + this.pad(Fromdate.getDate(), 2);
      this.endDate = Todate.getFullYear() + '-' + this.pad(Todate.getMonth() + 1, 2) + '-' + this.pad(Todate.getDate(), 2);

      this.startDateBook = Fromdate.getFullYear() + '-' + this.pad(Fromdate.getMonth() + 1, 2) + '-' + this.pad(Fromdate.getDate(), 2);
      this.endDateBook = Todate.getFullYear() + '-' + this.pad(Todate.getMonth() + 1, 2) + '-' + this.pad(Todate.getDate(), 2);
    }, 500);
  }

  pad(num, totalStringSize) {
    var asString = num + '';
    while (asString.length < totalStringSize) asString = '0' + asString;
    return asString;
  }

  onSubmit() {
    this.errorInfo = '';
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.loading = true;

    this.postDataSource['querystrings'] = {
      ownerId: this.ownerId,
      originalDtBeginDt: this.startDate,
      originalDtEndDt: this.endDate,
      bookDtBeginDt: this.startDateBook,
      bookDtEndDt: this.endDateBook
    }
    this.searchByKey();
    if (!this.isDatasourceInit) {
      this.gridOptions.api.setDatasource(this.postDataSource);
      this.isDatasourceInit = true
    }
    // setTimeout(() => {
    //   //SWMS-1181
    //   this.postDataSource = new PostDataSource({
    //     parent: this,
    //     service: this.stockInoutService,
    //     resultKey: 'stockinouts',
    //     querystrings: { ownerId: this.ownerId, originalDtBeginDt: this.startDate, originalDtEndDt: this.endDate }
    //   });
    //   this.gridOptions.api.setDatasource(this.postDataSource);
    //   if (this.postDataSource) this.gridOptions.api.hideOverlay();
    //   // this.searchByKey(); 
    //   this.gridHelper.selectedAnimateDelay();
    //   this.loading = false;
    //   this.working = false;
    // }, 1500);
  }

  onFilterClear() {
    this.gridOptions.api.setFilterModel(null);
  }

  changeOwner(selectedOwnerId) {
    if (selectedOwnerId !== undefined) {
      this.ownerId = selectedOwnerId;

      if (sessionStorage.getItem('ownerResult'))
        this.searchKeyOwnerTx = JSON.parse(sessionStorage.getItem('ownerResult')).ownerTx;
      // this.searchByKey();
    } else {
      this.ownerId = null;
      this.rowData = [];
      this.gridOptions.api.deselectAll();
      this.searchKeyOwnerTx = '';
      this.gridOptions.api.setFilterModel(null);
    }
    //setTimeout(() => {
      this.onSubmit();
    //}, 1500);
  }

  onEditButtonClick(node, $event) {
    this.editNode = node;
    event.stopPropagation();
    sessionStorage.setItem('rowStockinout', JSON.stringify(node['data']));
    this.isShow6022 = true;
  }

  clearSearchKey() {
    this.errorInfo = '';

    this.searchKeyItemcode = null;
    //this.searchKeyOwnerTx = null;
    this.searchKeyKubunSelected = '';
    this.startDate = null;
    this.endDate = null;
    this.startDateBook = null;
    this.endDateBook = null;
  }
  clearFilterKey() {
    this.errorInfo = '';
    // this.gridOptions.api.setFilterModel(null);
    var filters = {};
    if (this.ownerId != null) {
      filters['ownerId'] = {
        type: 'equals',
        filter: this.ownerId
      };
    }
    this.gridApi.api.setFilterModel(null);
    if (Object.getOwnPropertyNames(filters).length == 0) return;
    console.log(filters);
    this.gridApi.api.setFilterModel(filters);
  }

  clearAndSubmit() {
    this.clearFilterKey();
    this.selectedCount = 0;
  }
  searchByKey() {
    var filters = {};

    if (this.ownerId != null) {
      filters['ownerId'] = {
        type: 'equals',
        filter: this.ownerId
      };
    }

    if (this.searchKeyItemcode != null && this.searchKeyItemcode.length > 0) {
      filters['itemCd'] = {
        type: 'contains',
        filter: this.searchKeyItemcode
      };
    }

    if (this.searchKeyKubunSelected != '' && this.searchKeyKubunSelected.length > 0) {
      filters['typeoperationCd'] = {
        type: 'equals',
        filter: this.searchKeyKubun[this.searchKeyKubunSelected]['typeoperationCd']
      };
    }

    // this.gridOptions.api.setFilterModel(null);
    // if (this.startDate != null || this.endDate != null) {
    //   filters['originalDt'] = {
    //     type: 'inRange',
    //     dateFrom: this.startDate,
    //     dateTo: this.endDate
    //   };
    // }
    if (Object.getOwnPropertyNames(filters).length == 0) {
      this.gridApi.api.setFilterModel(null);
      return
    }
    console.log(filters);
    this.gridApi.api.setFilterModel(filters);
  }

  //表示件数の変更
  paginatorRowChange() {
    this.gridOptions.cacheBlockSize = Number(this.rowsPerPage);
    this.gridOptions.api.paginationSetPageSize(this.rowsPerPage);
    this.gridOptions.api.onSortChanged();
    localStorage.setItem('wa6020_rowsPerPage_idx', `${this.rowsPerPage}`);
  }

  csvDownload(csvString) {
    const str_to_unicode_array = str => {
      const arr = [];
      for (let i = 0; i < str.length; i++) {
        arr.push(str.charCodeAt(i));
      }
      return arr;
    };

    // Unicode コードポイントの配列に変換する
    const unicode_array = str_to_unicode_array(csvString);
    // S-JIS コードポイントの配列に変換
    const sjis_code_array = encoding.convert(
      unicode_array, // ※文字列を直接渡すのではない点に注意
      'SJIS', // to
      'UNICODE' // from
    );
    // 文字コード配列をTypedArrayに変換する
    const uint8_array = new Uint8Array(sjis_code_array);
    // 指定されたデータを保持するBlobを作成する
    const blob = new Blob([uint8_array], { type: 'text/csv' });
    // Internet Explorer
    if (window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, 'export.csv');
    } else {
      // Chrome
      const downloadLink = document.createElement('a');
      downloadLink.href = window.URL.createObjectURL(blob);
      downloadLink.download = 'export.csv';
      document.body.appendChild(downloadLink);
      downloadLink.click();
      document.body.removeChild(downloadLink);
    }
  }

  showCSVDownloadModal() {
    this.errorInfoForCSV = '';
    this.csvDownloadType = null;
    this.isShowCSVDownloadModal = true;
  }

  CSVDownlod () {
    const filterModel = this.gridApi.api.getFilterModel()
    this.working = true
    this.stockInoutService
    .downloadCsv({
      ownerId: this.ownerId,
      originalDtBeginDt: this.startDate,
      originalDtEndDt: this.endDate,
      bookDtBeginDt: this.startDateBook,
      bookDtEndDt: this.endDateBook,
      filterModel: filterModel
    })
    .then(resultCsv => {
      this.working = false
      console.log(resultCsv)

      const blob = new Blob(this.commonService.toSJis(resultCsv.fileContents), {type: 'text/csv'});
      
      // Internet Explorer
      if (window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, resultCsv.fileName);
      } else {
        // Chrome
        const downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(blob);
        downloadLink.download = resultCsv.fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
      }
    })
    .catch(error => {
      this.working = false;
      console.log(this.commonService.getErrorMessage(error));
      this.errorInfo = this.commonService.getErrorMessage(error);
    });
  }

  CSVDownlodLocal() {
    //SW-2103　ダブルクリック抑止
    if (this.working) return;
    this.working = true;
    this.errorInfoForCSV = '';
    this.csvDownloadType = '0';
    if (this.csvDownloadType == null) {
      this.errorInfoForCSV = 'ダウンロードする範囲を選択してください。';
      this.working = false;
      return;
    }

    var csvString = '';
    if (this.csvDownloadType == '0') {
      if (this.gridOptions.api.getSelectedNodes().length == 0) {
        this.errorInfoForCSV = '対象を選択して下さい。';
        this.working = false;
        return;
      }
      csvString = this.gridApi.api.getDataAsCsv({
        onlySelected: true
      });
    } else {
      var headerFields = [];
      var headerIndex = 0;
      this.gridOptions.columnDefs.forEach(value => {
        csvString += value['headerName'];

        if (headerIndex != this.gridOptions.columnDefs.length - 1) csvString += ',';

        headerFields.push(value['field']);
        headerIndex++;
      });
      csvString += '\r\n';

      this.gridOptions.api.getModel().forEachNode(rowNode => {
        headerIndex = 0;
        var data = rowNode.data;
        var _dataString = '';
        headerFields.forEach(fieldName => {
          _dataString += data[fieldName] == null ? '' : data[fieldName];
          if (headerIndex != headerFields.length - 1) _dataString += ',';
          headerIndex++;
        });
        _dataString += '\r\n';
        csvString += _dataString;
      });
    }
    
    this.csvDownload(csvString);
    this.isShowCSVDownloadModal = false;
    setTimeout(() => {
      this.working = false;
    },300);
  }

  onShow6022Change(isCloseAndRefreshGrid: boolean) {
    this.isShow6022 = false;
    if (isCloseAndRefreshGrid) {
      this.gridHelper.prepareSelectedAnimateByNodes([this.editNode]);
      this.onSubmit();
    }
  }

  onSearchBlockClick() {
    this.errorInfo = '';
    this.isShowSearchBlock = !this.isShowSearchBlock;
    this.gridHelper.renderScrollArrowDelay();
  }

  ngDoCheck() {
    this.itemCodeCls = this.searchKeyItemcode == null || this.searchKeyItemcode.length == 0 ? '' : 'active';
    this.kubunCls = this.searchKeyKubunSelected == null || this.searchKeyKubunSelected.length == 0 ? '' : 'active';
    // this.startDateCls = this.startDate == null || this.startDate.length == 0 ? '' : 'active';
    // this.endDateCls = this.endDate == null || this.endDate.length == 0 ? '' : 'active';
  }

  ownerInputChanged(ownerId: string) {
    this.gridHelper.isOwnerNotFound = ownerId == null && ownerId !== undefined;
    this.changeOwner(ownerId);
  }

  clrErr() {
    this.errorInfo = '';
  }

  fixedSelectAll() {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.classList.remove('ag-hidden')
    selectAll.addEventListener('click', () => {
      const nodes = this.gridOptions.api.getRenderedNodes()
      if (nodes.length > 0 && nodes[0].data === null) {
        this.gridSelectAll = !this.gridSelectAll
        return
      }

      this.gridSelectAll = !this.gridSelectAll
      this.selectCurrentPage(this.gridSelectAll)
    })
  }

  selectCurrentPage (selected) {
    const startRow = (this.paginationGetCurrentPage - 1) * Number(this.rowsPerPage)
    const endRow = startRow + Number(this.rowsPerPage)

    this.gridOptions.api.forEachNode(node => {
      if (node.data)
        node.setSelected(false)
    })
    const count = this.gridOptions.api.getDisplayedRowCount()
    const limit = count < endRow ? count : endRow

    for (let i = startRow; i < endRow; i++) {
      const node = this.gridOptions.api.getDisplayedRowAtIndex(i)
      if (node.data)
        node.setSelected(selected)
    }
  }

  selectAllClick () {
    var selectAll = this.gridView.nativeElement.querySelector('.ag-header-row .ag-header-select-all');
    selectAll.click()
  }

  handleBeforeRequest () {
    this.gridOptions.api.showLoadingOverlay()
  }

  handleRequestSucc () {
    this.gridHelper.selectedAnimateDelay();
    this.loading = false;
    this.gridOptions.api.hideOverlay()
  }

}



// WEBPACK FOOTER //
// /home/runner/work/saas_wms_prod_ui_pc/saas_wms_prod_ui_pc/src/app/pages/wa6Stock/wa6020/wa6020.component.ts